















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class Checkbox extends Vue {
  @Prop()
  onCheck: (value: boolean, checked: boolean) => void;

  @Prop()
  id: string;

  @Prop()
  label: string;

  @Prop()
  classes: string[];

  @Prop()
  value: boolean;

  @Prop()
  checked: boolean;

  @Prop()
  disabled: boolean;

  onClick (e: HTMLInputElement) {
    this.onCheck(this.value, e.checked);
  }
}

